export enum RichTextFont {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
